import { useState } from "react";
import ModalVideo from "react-modal-video";
import { Link } from "react-router-dom";
import Slider from "react-slick";

import sliderImg1 from "../../assets/images/banner2/banner_1.jpeg";
import sliderImg2 from "../../assets/images/banner2/banner_2.jpg";
import sliderImg3 from "../../assets/images/banner2/banner_3.jpg";
import sliderImg4 from "../../assets/images/banner2/banner_4.jpeg";

const HomeSlider = () => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(!isOpen);

  const sliderSettings = {
    dots: true,
    arrows: true,
    infinite: true,
    margin: 0,
    centerMode: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          arrows: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          arrows: false,
        },
      },
    ],
  };

  const data = [
    {
      img: "/img/home/empowering-lives.avif",
      title: "Empowering Lives for a Brighter Future",
    },
    {
      img: "/img/home/shaping-dreams.jpg",
      title: "Shaping Dreams Into Reality",
    },
    {
      img: "/img/home/building-confidence.jpg",
      title: "Building Confidence, Creating Tomorrow",
    },
    {
      img: "/img/home/building-future.avif",
      title: "Crafting Futures with Purpose and Pride",
    },
    // Turning Aspirations Into Achievements
  ];

  return (
    <>
      <div className="react-slider-part">
        <ModalVideo
          channel="youtube"
          isOpen={isOpen}
          videoId="e5Hc2B50Z7c"
          onClose={() => {
            openModal();
          }}
        />
        <div className="home-sliders home2">
          <Slider {...sliderSettings}>
            {data?.map((item, idx) => (
              <div className="single-slide">
                <div className="slider-img">
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <img
                      className="desktop"
                      src={item?.img}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                      alt={`Slider banner ${idx + 1}`}
                    />
                            <img
                    className="mobile"
                    src={item?.img}
                    alt={`Slider banner ${idx + 1}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.4)", // black with 40% opacity
                        pointerEvents: "none", // so overlay doesn't block interactions
                      }}
                      className="desktop"
                    />
                  </div>
          
                </div>
                <div className="container">
                  <div className="slider-content">
                    <div className="content-part">
                      <h2
                        className="slider-title wow animate__fadeInUp col-md-7"
                        data-wow-duration="1s"
                      >
                        <span style={{ color: "#F2F2F2" }}>{item?.title}</span>
                      </h2>

                      <div
                        className="slider-btn wow animate__fadeInUp"
                        data-wow-duration="1.2s"
                      >
                        <Link to="/about" className="react-btn-border">
                          Know More
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {/* <div className="single-slide">
              <div className="slider-img">
                <img
                  className="desktop"
                  style={{width:"100%",objectFit:"cover"}}
                  src={sliderImg2}
                  
                  alt="Slider Image 1"
                />
                <img className="mobile" src={sliderImg1} alt="Slider Image 1" />
              </div>
              <div className="container">
                <div className="slider-content">
                <div className="content-part">
                    <h2
                      className="slider-title wow animate__fadeInUp"
                      data-wow-duration="1s"
                    >
                   <span style={{ color: "#FE7743" }}>Empowering Lives for <br /> A Brighter Future </span>
                    </h2>
                    <div
                      className="slider-btn wow animate__fadeInUp"
                      data-wow-duration="1.2s"
                    >
                      <Link to="/about" className="react-btn-border">
                        Know More
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="single-slide">
              <div className="slider-img">
                <img
                  className="desktop"
                  src={sliderImg3}
                  style={{width:"100%",objectFit:"cover"}}
                  alt="Slider Image 1"
                />
                <img className="mobile" src={sliderImg1} alt="Slider Image 1" />
              </div>
              <div className="container">
                <div className="slider-content">
                <div className="content-part">
                    <h2
                      className="slider-title wow animate__fadeInUp"
                      data-wow-duration="1s"
                    >
                    <span style={{ color: "#FE7743" }}>Empowering Lives for <br /> A Brighter Future </span>
                    </h2>
                    <p style={{ color: "white",fontWeight:"bold" }}>
                    Since 2008, Ocfit has been a beacon of hope for individuals from remote areas, <br /> lower socio-economic backgrounds, and those with disabilities. By focusing on empowerment, <br /> Ocfit is dedicated to improving social strata and <br /> living conditions through financial independence and job readiness.
                    </p>
                    <div
                      className="slider-btn wow animate__fadeInUp"
                      data-wow-duration="1.2s"
                    >
                      <Link to="/about" className="react-btn-border">
                        Know More
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="single-slide">
              <div className="slider-img">
                <img
                  className="desktop"
                  style={{width:"100%",objectFit:"cover"}}
                  src={sliderImg1}
                  
                  alt="Slider Image 1"
                />
                <img className="mobile" src={sliderImg4} alt="Slider Image 1" />
              </div>
              <div className="container">
                <div className="slider-content">
                <div className="content-part">
                    <h2
                      className="slider-title wow animate__fadeInUp"
                      data-wow-duration="1s"
                    >
                     <span style={{ color: "#FE7743" }}>Empowering Lives for <br /> A Brighter Future </span>
                    </h2>
                    <p style={{ color: "white",fontWeight:"bold" }}>
                    Since 2008, Ocfit has been a beacon of hope for individuals from remote areas, <br /> lower socio-economic backgrounds, and those with disabilities. By focusing on empowerment, <br /> Ocfit is dedicated to improving social strata and <br /> living conditions through financial independence and job readiness.
                    </p>
                    <div
                      className="slider-btn wow animate__fadeInUp"
                      data-wow-duration="1.2s"
                    >
                      <Link to="/about" className="react-btn-border">
                        Know More
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </Slider>
        </div>
      </div>
    </>
  );
};

export default HomeSlider;
